const points = [
  { icon: '⚡', title: 'Faster Delivery', desc: 'AI-assisted development cuts build time significantly without sacrificing quality.' },
  { icon: '🎯', title: 'Smarter Code', desc: 'Automated review and testing catch issues early, resulting in cleaner, more reliable software.' },
  { icon: '💰', title: 'Lower Cost', desc: 'Less time spent on repetitive tasks means better value for your budget.' },
  { icon: '🤖', title: 'Built-in AI Features', desc: 'Need a chatbot, automation, or smart search? I integrate AI natively into your product.' },
];

export default function AIBanner() {
  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="bg-gradient-to-br from-violet-950/60 to-indigo-950/40 border border-violet-500/20 rounded-3xl p-10 md:p-14">

          <div className="text-center mb-12">
            <span className="text-xs font-medium tracking-widest text-indigo-300 uppercase border border-indigo-400/30 px-4 py-1.5 rounded-full">
              The AI Advantage
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-white mt-5 mb-3">
              Development accelerated by AI.
            </h2>
            <p className="text-gray-400 text-sm max-w-lg mx-auto">
              I use AI throughout every stage of development — not just as a feature, but as a core part of how I work.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {points.map(({ icon, title, desc }) => (
              <div key={title} className="text-center">
                <div className="text-3xl mb-3">{icon}</div>
                <h4 className="text-white font-semibold text-sm mb-2">{title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
}
